<template>
  <div class="h-100 d-flex flex-column">

    <!-- se sono in home c'è la classe header-bar-home -->
    <NavbarMobile
        v-if="!this.isMobile || $route.name !== 'home'"
        :show-navbar="showNavbar"
        :is-rooms-route="isRoomsRoute"
        :navbar-top-inset="navbarTopInset"
        :headerbar-title="headerbarTitle"
        @back="handleBackNavigation"
    />

    <nav v-if="this.show_navbar && !this.isRoomsRoute" class="d-none d-md-block navbar-expand navbar-default" :style="{ paddingTop: navbarTopInset + 6 + 'px' }">
      <div class="navbar container-md">
        <ul class="navbar-nav d-flex justify-content-between align-items-center">
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'home'}">
              <span class="material-symbols-outlined icone30">home</span>
            </router-link>
          </li>
          <!-- + locali -->
          <inc-dropdown-rooms v-if="this.isMultiChoice"/>
        </ul>

        <ul class="navbar-nav navbar-right d-flex justify-content-between align-items-center">
          <li class="nav-item">
            <router-link :to="{name:'presentation'}" class="nav-link">
              {{ $t('layout_chi_siamo') }}
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="{name:'orders'}" class="nav-link text-capitalize">
              {{ $t('ristorante_ordina_btn') }}
            </router-link>
          </li>

          <li class="nav-item d-none d-md-block" v-if="this.enableReservations">
            <router-link :to="{name:'reservations.reserve'}" class="nav-link" v-if="!this.locale.prenota_tavolo_external_url">
                      <span class="d-none badge badge-info">
                        {{ $t('prenotazione_tavolo.submit_btn') }}
                      </span>
              {{ $t('prenotazione_tavolo.submit_btn') }}
            </router-link>

            <a target="_blank" :href="`${this.locale.prenota_tavolo_external_url}`" class="nav-link" v-if="this.locale.prenota_tavolo_external_url">
                      <span class="d-none badge badge-info">
                       {{ $t('prenotazione_tavolo.submit_btn') }}
                      </span>
              {{ $t('prenotazione_tavolo.submit_btn') }}
            </a>
          </li>

          <li class="nav-item" v-if="!this.userAuthenticated">
            <router-link :to="{name:'user.login'}" v-tooltip:bottom="$t('layout_profilo_tooltip')" class="nav-link">
              <span class="material-symbols-outlined icone30">person</span>
            </router-link>
          </li>

          <!-- compare solo le sono loggato -->
          <li class="nav-item" v-if="this.userAuthenticated">
            <router-link :to="{name:'user'}" v-tooltip:bottom="$t('layout_profilo_tooltip')" class="nav-link">
              <span class="material-symbols-outlined icone30">person</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="{name: 'sondaggio'}" v-tooltip:bottom="$t('ristorante_sondaggio')"
                         class="nav-link">
              <span class="material-symbols-outlined icone30">cards_star</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="this.userAuthenticated && this.enableMessaging">
            <router-link :to="{name:'messaging'}" v-tooltip:bottom="$t('messaggistica')" class="nav-link">
                      <span class="icon-wrapper position-relative">
                        <span class="material-symbols-outlined icone30">mark_as_unread</span>
                        <span class="badge badge-info badge-app-nav rounded-pill position-absolute" v-if="this.unread_messages_counter">
                                    {{ this.unread_messages_counter }}
                                </span>
                        </span>
                    </router-link>
                  </li>
                    <li class="nav-item" v-if="this.enableCoupons">
                        <router-link :to="{name: 'orders.discounts'}" v-tooltip:bottom="$t('layout_opzioni_label_csconto_tooltip')" class="nav-link">
                          <span class="icon-wrapper position-relative">
                            <span class="material-symbols-outlined icone30">
                              percent_discount
                            </span>
                            <span class="badge badge-info badge-app-nav rounded-pill position-absolute" v-if="!!counter_discount_codes">
                              {{ counter_discount_codes }}
                            </span>
                          </span>
                        </router-link>
                    </li>
                  <li class="nav-item" v-if="this.enableFidelityCard">
                    <router-link :to="{name:'fidelity'}" v-tooltip:bottom="$t('layout_fidelity_card')"
                                 class="nav-link">
                       <span class="material-symbols-outlined icone30">
                          redeem
                        </span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{name:'notifiche'}" v-tooltip:bottom="$t('layout_notifiche')"
                                 class="nav-link">
                       <span class="icon-wrapper position-relative">
                        <span class="material-symbols-outlined icone30">notifications_active</span>
                        <!-- deve essere implementato a database -->
                        <!--<span class="badge badge-info badge-app-nav rounded-pill position-absolute">
                                   1
                                </span>-->
                        </span>
                    </router-link>
                  </li>

                    <li class="nav-item">

                        <router-link :to="{name:'cart'}" v-tooltip:bottom="$t('layout_carrello_tooltip')" class="nav-link">
                          <span class="icon-wrapper position-relative">
                            <span class="material-symbols-outlined icone30">shopping_cart</span>
                            <span class="badge badge-info badge-app-nav rounded-pill position-absolute" v-if="this.order.total_items">
                                    {{ this.order.total_items }}
                            </span>
                          </span>
                        </router-link>
                    </li>


          <!--
            <li class="nav-item d-none d-md-block" v-if="!this.userAuthenticated">
                <router-link :to="{name:'user.registration'}" class="nav-link">
                    <i class="pi pi-user"></i> Registrati
                </router-link>
            </li>

            <li class="nav-item d-none d-md-block" v-if="this.userAuthenticated">
                <a href="#" v-tooltip:bottom="'Logout'" class="nav-link"
                   @click.prevent="handleLogout()">
                    <i class="pi pi-unlock"></i> Logout
                </a>
            </li> -->
        </ul>
      </div>
    </nav>
    <!-- , 'optionbar-app' : this.isMobile() -->
    <div v-if="this.show_optionbar && !this.isRoomsRoute" class="border-bottom optionbar mx-0" :class="{'d-none': $route.name === 'home', 'optionbar-app' : this.isMobile()}">
      <div class="container-md d-flex justify-content-between px-0">
        <div class="flex-grow-1">
          <router-link :to="{name:'orders'}" class="a1 d-inline-flex align-items-center flex-grow-1">
              <i class="pi pi-sliders-h mr-3"></i>
              <div v-if="this.order_started">
                    <span class="optionbar-blinker-wrapper">
                      <transition name="blinker-fade" mode="out-in">
                          <span :key="this.currentBlinkerKey" class="optionbar-blinker-item">
                              <span v-if="this.currentBlinkerKey === 0">
                                  <span v-if="this.order.label_tipologia">
                                      {{ this.order.label_tipologia }}
                                  </span>
                                  <span v-else-if="this.order.type === 'TAKEAWAY'">
                                      {{ $t('takeaway') }}
                                  </span>
                                  <span v-else-if="this.order.type === 'DELIVERY'">
                                      {{ $t('delivery') }}
                                  </span>
                                  <span v-else-if="this.order.type === 'MANGIA_RISTORANTE'">
                                      {{ $t('eat_at_restaurant') }}
                                  </span>
                                  <span v-else-if="this.order.type === 'ORDINA_TAVOLO'">
                                      {{ $t('al_tavolo') }}
                                  </span>
                                  <span v-else>
                                      {{ this.order.type }}
                                  </span>
                              </span>
                              <span v-else-if="this.currentBlinkerKey === 1">
                                  {{ this.orderOptionsDescription(this.language) }}
                              </span>
                              <span v-else-if="this.currentBlinkerKey === 2" class="d-inline-flex align-items-center text-lowercase f12">
                                (<span class="material-symbols-outlined mx-1">acute</span> <i>{{ $t('ordine_appena_possibile') }}</i>)
                              </span>
                              <span v-else-if="this.currentBlinkerKey === 3">
                                  {{ this.order.address.formatted_address }}
                              </span>
                          </span>
                      </transition>
                    </span>
                </div>
          <span v-else>
                    {{ this.specificTranslation("quando_vuoi_mangiare") }}
                </span>
        </router-link>
        </div>
        <router-link :to="{name:'menu.categories'}" class="a1" v-if="this.order_started">
          <i class="pi pi-book mr-2"></i>
          <b class="text-uppercase">{{ $t('ordine_menu_btn') }}</b>
        </router-link>
      </div>
      <transition name="fade">
        <mcw-linear-progress indeterminate v-if="this.loading_visible"></mcw-linear-progress>
      </transition>
    </div>

    <section ref="mainSection" class="container-fluid p-0 d-flex flex-grow-1 flex-column">
      <NavbarMobile
          v-if="this.isMobile && $route.name === 'home'"
          :show-navbar="showNavbar"
          :is-rooms-route="isRoomsRoute"
          :navbar-top-inset="navbarTopInset"
          :headerbar-title="headerbarTitle"
          @back="handleBackNavigation"
      />

      <div v-if="this.$route.meta.showLogo" class="d-flex align-items-center logo">
        <inc-restaurant-logo :targa="this.targaRistorante"/>
      </div>
      <splash-screen v-if="this.splashscreen_visible" :targa="this.targaRistorante"/>
      <maintenance
          v-else-if="this.maintenance"
          :text="this.maintenanceText"
          :targa="this.targaRistorante"
          :id-ristorante="this.id_ristorante"
          :language="this.language"
          @maintenance-unlocked="handleMaintenanceUnlocked"
      />
      <div v-else class="h-100 w-100">
        <transition name="fade">
          <!--<keep-alive>-->
          <router-view></router-view>
          <!--</keep-alive>-->
        </transition>

        <inc-footer-languages
            v-if="!this.splashscreen_visible && !this.isMobile()"
            class="d-none d-md-block"
            :lingue-attive="this.lingue_attive"
        />
        <inc-copyright
            :class="['d-none d-md-block', {'d-block fixed-bottom': this.maintenance || this.isRoomsRoute}]"
            @open-privacy-modal="openPrivacyModal"
        /><!-- :class="['d-none d-md-block', {'d-block d-md-none': this.maintenance || this.isRoomsRoute}]"-->
      </div>
    </section>

    <div
        v-if="this.show_cookie_banner && !this.isMobile()"
        class="alert text-center cookiealert rounded-0 mb-0"
        role="alert"
        :style="{ bottom: this.cookieBannerBottomOffset + 'px' }"
    >
      Questo sito fa uso di cookie per migliorare l'esperienza di navigazione degli utenti e per raccogliere
      informazioni sull'utilizzo del sito stesso. Utilizziamo sia cookie tecnici sia cookie di parti terze per
      inviare messaggi promozionali sulla base dei comportamenti degli utenti. Può conoscere i dettagli consultando
      la nostra
      <a href="#" class="a-nobkg text-decoration-underline" @click.prevent="openCookiePolicyModal()">
        privacy policy
      </a>.
      <br>
      <button
          type="button"
          class="btn btn-primary btn-sm mt-2 acceptcookies"
          aria-label="Accetta cookie"
          @click="acceptCookies"
      >
        Accetto
      </button>
    </div>

    <nav v-if="this.show_navbar && !this.isRoomsRoute" class="navbar-expand navbar-default-app d-md-none" :style="{ paddingBottom: navbarBottomInset + 'px' }">
      <div class="container">
        <ul class="navbar-nav navbar-nav-app nav-fill d-flex justify-content-between w-100">
          <li class="nav-item">
            <router-link  class="nav-link d-flex flex-column" :to="{name: 'home'}">
              <span class="material-symbols-outlined icone30">home</span>
              Home
            </router-link>
          </li>

          <li class="nav-item" v-if="!this.userAuthenticated">
            <router-link :to="{name:'user.login'}"
                         class="nav-link d-flex flex-column">
              <span class="material-symbols-outlined icone30">person</span>
              Profilo
            </router-link>
          </li>

          <!-- compare solo le sono loggato -->
          <li class="nav-item" v-if="this.userAuthenticated">
            <router-link :to="{name:'user'}"
                         class="nav-link d-flex flex-column">
              <span class="material-symbols-outlined icone30">person</span>
              {{ $t('layout_profilo_tooltip') }}
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="{name:'orders'}"
                         class="nav-link d-flex flex-column">
              <span class="material-symbols-outlined icone30">menu_book</span>
              {{ $t('ordina') }}
            </router-link>
          </li>

          <li class="nav-item">
              <span class="badge badge-info badge-cart-app rounded-pill position-absolute" v-if="this.order.total_items">
                {{ this.order.total_items }}
              </span>
            <router-link :to="{name:'cart'}"
                         class="nav-link d-flex flex-column">
              <span class="material-symbols-outlined icone30">shopping_cart</span>
              <div>{{ $t('layout_carrello_tooltip') }}</div>

            </router-link>
          </li>

          <!-- + locali
          <inc-dropdown-rooms v-if="this.isMultiChoice"/>
          -->

          <!-- registrazione
         <li class="nav-item d-none d-md-block" v-if="!this.userAuthenticated">
           <router-link :to="{name:'user.registration'}"
                        v-tooltip:bottom="$t('account.registrazione')" class="nav-link">
             <i class="fas fa-pencil-alt"></i>
           </router-link>
         </li>
         -->

          <!-- logout
          <li class="nav-item d-none d-md-block" v-if="this.userAuthenticated">
            <a href="#" v-tooltip:bottom="'Logout'" class="nav-link"
               @click.prevent="handleLogout()">
              <i class="fa fa-unlock-alt"></i>
            </a>
          </li>
          -->
        </ul>
      </div>
    </nav>

    <div class="sidebar">
      <b-sidebar
          id="sidebar-right"
          :title="sidebarRestaurantName"
          width="280px"
          backdrop-variant="dark"
          backdrop
          shadow
          right
      >
        <template #header="{ hide }">
          <div class="d-flex align-items-center justify-content-between w-100">
                <button type="button" class="close sidebar-close-btn" aria-label="Close" @click="hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <router-link :to="{name: 'home'}" class="text-dark font-weight-bold">
                    {{ sidebarRestaurantName }}
                </router-link>
          </div>
        </template>

        <template #footer="{ hide }">
          <div class="d-flex align-items-center justify-content-center px-3 py-2">
            Powered by <img src="/img/be/logo-kuokko.svg" width="70">
          </div>
        </template>

        <nav class="sidebar-nav mb-3">
          <b-nav vertical>
            <b-nav-item :to="{name:'orders'}">{{$t("ristorante_ordina_btn")}}</b-nav-item>
            <b-nav-item :to="{name:'sondaggio'}">{{$t("ristorante_sondaggio")}}</b-nav-item>
            <b-nav-item v-if="this.enableCoupons" :to="{name:'orders.discounts'}">{{$t("layout_opzioni_label_csconto_tooltip")}}</b-nav-item>
            <b-nav-item v-if="this.enableFidelityCard"
                        :to="{name:'fidelity'}">{{$t("layout_fidelity_card")}}</b-nav-item>
            <b-nav-item v-if="this.enableReservations && !this.locale.prenota_tavolo_external_url"
                        :to="{name:'reservations.reserve'}">{{$t("layout_prenota_tooltip")}}</b-nav-item>
            <b-nav-item v-if="this.enableReservations && this.locale.prenota_tavolo_external_url"
                        :href="`${this.locale.prenota_tavolo_external_url}`">{{$t("layout_prenota_tooltip")}}</b-nav-item>
            <b-nav-item v-if="this.userAuthenticated && this.enableMessaging"
                        :to="{name:'messaging'}">{{$t("messaggistica")}}</b-nav-item>
            <b-nav-item v-b-toggle.collapse-ristorante>{{$t("ristorante")}}</b-nav-item>
            <b-collapse id="collapse-ristorante" class="sidebar-nav-dropdown">
              <b-nav vertical>
                <b-nav-item :to="{name:'presentation'}">{{$t("layout_chi_siamo")}}</b-nav-item>
                <b-nav-item :to="{name:'news.list'}">{{$t("layout_news")}}</b-nav-item>
                <b-nav-item :to="{name:'orari'}">{{$t("layout_orari")}}</b-nav-item>
              </b-nav>
            </b-collapse>
            <hr>
            <b-nav-item v-b-toggle.collapse-account v-if="this.userAuthenticated">{{$t('account')}}</b-nav-item>
            <b-collapse id="collapse-account" class="sidebar-nav-dropdown" v-if="this.userAuthenticated">
              <b-nav vertical>
                <b-nav-item :to="{name:'user'}">{{$t('layout_profilo_tooltip')}}</b-nav-item>
                <b-nav-item :to="{name:'user.payments'}">{{$t('metodi_pagamento_title')}}</b-nav-item>
                <b-nav-item :to="{name:'user.addresses'}">{{$t('layout_indirizzi_consegna')}}</b-nav-item>
                <b-nav-item :to="{name:'orders.history'}">{{$t('account.storico_ordini')}}</b-nav-item>
                <b-nav-item :to="{name:'reservations.history'}" v-if="this.enable_reservations">{{$t('prenotazione.storico')}}</b-nav-item>
                <!--<b-nav-item>ingredienti preferiti</b-nav-item>-->
                <b-nav-item href="#" @click.prevent="openPrivacyModal('privacy')">{{$t('layout_privacy')}}</b-nav-item>
                <b-nav-item href="#" @click.prevent="openPrivacyModal('termini')">{{$t('termini_condizioni.titolo')}}</b-nav-item>
              </b-nav>
            </b-collapse>
            <b-nav-item :to="{name:'notifiche'}" v-if="this.userAuthenticated">{{$t('layout_notifiche')}}</b-nav-item>
            <b-nav-item :to="{name:'impostazioni'}">{{$t('layout_impostazioni')}}</b-nav-item>
            <hr>
            <a href="#" @click.prevent="handleLogout()" class="a4 p-2 d-flex align-items-center text-capitalize" v-if="this.userAuthenticated">
              <i class="pi pi-unlock f4 mr-2"></i> {{$t('layout_logout')}}
            </a>
            <router-link :to="{name:'user.login'}" class="a4 p-2 d-flex align-items-center text-capitalize" v-if="!this.userAuthenticated">
              <i class="pi pi-lock f4 mr-2"></i> {{$t('layout_login')}}
            </router-link>
          </b-nav>
        </nav>

      </b-sidebar>
    </div>

    <modal-reset-cart-confirm v-if="this.show_modal_cart_reset"/>
    <modal-cart-expired v-if="this.show_modal_cart_expired"/>
    <modal-cart-timer v-if="this.show_modal_cart_timer"/>

    <modal-errors v-if="this.show_modal_errors"/>

    <modal v-if="this.show_privacy_modal" @close="show_privacy_modal = false" :show-title="true">
      <div slot="header">
        <h5 class="modal-title">{{ this.current_privacy_checkbox ? this.current_privacy_checkbox.label : '' }}</h5>
      </div>
      <div slot="body">
        <iframe :src="this.current_privacy_checkbox ? this.current_privacy_checkbox.url : ''"
                class="w-100"
                style="height:500px;"
                frameBorder="0">
          Browser not compatible
        </iframe>
      </div>
    </modal>

    <modal-cookie-policy
        v-if="this.show_cookie_policy_modal"
        @close="show_cookie_policy_modal = false"
        @open-privacy="openPrivacyFromCookiePolicy"
    />
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import { getCoupons, sendFirebaseToken, status } from '../api/account';
import { getRestaurantInfo, getStatus, getPrivacyCheckboxes } from '../api/restaurant';

import firebase from "../firebase/firebase-service";

import IncCopyright from './partials/IncCopyright';
import IncFooterLanguages from './partials/IncFooterLanguages';
import IncRestaurantLogo from './partials/IncRestaurantLogo';
import SplashScreen from './SplashScreen';
import Maintenance from './Maintenance';
import ModalErrors from "./partials/ModalErrors";
import ModalConfirm from './partials/ModalConfirm';
import Modal from './partials/Modal';
import ModalCartExpired from './cart/partials/ModalCartExpired';
import ModalCartTimer from './cart/partials/ModalCartTimer';
import ModalResetCartConfirm from './partials/ModalResetCartConfirm';
import ModalCookiePolicy from './partials/ModalCookiePolicy';
import IncDropdownRooms from "./partials/IncDropdownRooms";
import IconTableHome from "../components/IconTableHome.vue";
import IconOrderHome from "../components/IconOrderHome.vue";
import IconInfo from "../components/IconInfo.vue";
import NavbarMobile from "./partials/NavbarMobile.vue";

export default {
    provide() {
        return {
            openPrivacyModal: (payload) => this.openPrivacyModal(payload)
        };
    },
    props: ['idRistorante', 'targaRistorante', 'fwpcRistorante'],
    components: {
      NavbarMobile,
      IconInfo,
      IconOrderHome,
      IconTableHome,
        IncDropdownRooms,
        Modal,
        ModalErrors,
        ModalResetCartConfirm,
        ModalCartTimer,
        ModalCartExpired,
        ModalCookiePolicy,
        IncCopyright,
        IncFooterLanguages,
        IncRestaurantLogo,
        SplashScreen,
        Maintenance,
        ModalConfirm
    },
    data() {
        return {
            id_ristorante: this.idRistorante,
            lingue_attive: [],
            counter_discount_codes: null,
            maintenance: false,
            maintenanceText: null,
            maintenance_unlocked: false,
            show_navbar: false,
            show_optionbar: false,
            can_receive_notifications: false,
            privacy_checkboxes: [],
            privacy_cache_key: null,
            show_privacy_modal: false,
            current_privacy_checkbox: null,
            show_cookie_policy_modal: false,
            show_cookie_banner: false,
            navbarBottomInset: 0,
            navbarTopInset: 0
        }
    },
    created() {
        // Leggo gli insets dalla mobile app
        if (window.kuokkoMobileAppInsets) {
            if (window.kuokkoMobileAppInsets.bottom) {
                this.navbarBottomInset = window.kuokkoMobileAppInsets.bottom;
                document.documentElement.style.setProperty('--navbar-bottom-inset', this.navbarBottomInset + 'px');
            }
            if (window.kuokkoMobileAppInsets.top) {
                this.navbarTopInset = window.kuokkoMobileAppInsets.top;
                document.documentElement.style.setProperty('--navbar-top-inset', this.navbarTopInset + 'px');
            }
        }

        //per prima cosa setto la lingua
        this.$root.$i18n.locale = this.language;

        //fetcho
        this.showSplashscreen(true);
        this.fetchInfo();

        if (this.userAuthenticated) {
            //setup firebase
            this.setupFirebase();
        }
    },
    mounted() {
        this.initCookieBanner();
    },
    computed:
        {
        showNavbar() {
            return this.show_navbar;
        },
        headerbarTitle() {
            const meta = (this.$route && this.$route.meta) ? this.$route.meta : {};
            if (meta.headerTitle) {
                return meta.headerTitle;
            }
            if (meta.headerTitleKey) {
                return this.$t(meta.headerTitleKey);
            }
            return '';
        },
        sidebarRestaurantName() {
            if (this.locale && this.locale.nome_locale) {
                return this.locale.nome_locale;
            }

            return this.$t('ristorante');
        },
        isRoomsRoute() {
            return !!(this.$route && this.$route.name && this.$route.name.startsWith('rooms'));
        },
        cookieBannerBottomOffset() {
            const isSmallScreen = window.matchMedia('(max-width: 767px)').matches;
            const hasBottomNavbar = isSmallScreen && this.show_navbar && !this.isRoomsRoute;

            if (hasBottomNavbar) {
                return 71 + this.navbarBottomInset;
            }

            return this.navbarBottomInset;
        },
        currentBlinkerKey() {
            if (!this.order || !this.order.blinker_keys || !this.order.blinker_keys.length) {
                return 0;
            }

            const key = this.order.blinker_keys[this.order.blinker_idx];
            return key === undefined || key === null ? 0 : key;
        },
        ...mapGetters('restaurant', {
            enable_reservations: 'enableReservations',
        }),
        ...mapGetters('restaurant', [
            'enableReservations',
            'enableFidelityCard',
            'enableMessaging',
            'enableCoupons',
            'isMultiChoice',
            'restaurantServices',
            'specificTranslation'
        ]),
        ...mapGetters('auth', {
            userAuthenticated: 'authenticated'
        }),
        ...mapGetters('chat', {
            unread_messages_counter: 'counter'
        }),
        ...mapGetters('order', {
            order_started: 'started',
            orderOptionsDescription: 'optionsDescription'
        }),
        ...mapState('localization', {
            language: state => state.language,
            initialized: state => state.initialized,
        }),
        ...mapState('global', {
            splashscreen_visible: state => state.splashscreen_visible,
            loading_visible: state => state.loading_visible,
            show_modal_cart_expired: state => state.show_modal_cart_expired,
            show_modal_cart_timer: state => state.show_modal_cart_timer,
            show_modal_cart_reset: state => state.show_modal_cart_reset,
            show_modal_errors: state => state.show_modal_errors,
            cart_summary_checkout_step: state => state.cart_summary_checkout_step
        }),
        ...mapState('restaurant', {
            restaurant: state => state,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('chat', {
            unread_messages: state => state.unread_messages
        })
    },
    watch: {
        language: function () {
            this.fetchInfo();
        },
        userAuthenticated: function (authenticated) {
            if (authenticated) {
                if (!window.isKuokkoMobileApp) {
                    this.setupFirebase();
                    this.retrieveMessages();
                }
            } else {
                if (!window.isKuokkoMobileApp) {
                    //remove firebase instance
                    firebase.destroy();
                }
                this.can_receive_notifications = false;
            }
        },
        locale: function (newLocale, oldLocale) {
            if (!oldLocale || (newLocale.id !== oldLocale.id)) {
                this.fetchMoreInfo();
            }
        },
        $route(to, from) {
            // react to route changes...
            this.show_navbar = !this.splashscreen_visible && !this.maintenance && to.meta.showNav;
            this.show_optionbar = !this.splashscreen_visible && !this.maintenance && to.meta.showOptionbar;
            if (this.$refs.mainSection) {
                this.$refs.mainSection.scrollTop = 0;
            }
        }
    },
    methods: {
        initCookieBanner() {
            this.show_cookie_banner = !this.getCookie('acceptCookies');
        },
        acceptCookies() {
            this.setCookie('acceptCookies', 'true', 365);
            this.show_cookie_banner = false;
        },
        openCookiePolicyModal() {
            this.show_cookie_policy_modal = true;
        },
        openPrivacyFromCookiePolicy() {
            this.show_cookie_policy_modal = false;
            this.openPrivacyModal('privacy');
        },
        setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            const expires = 'expires=' + d.toUTCString();
            document.cookie = `${cname}=${cvalue};${expires};path=/`;
        },
        getCookie(cname) {
            const name = `${cname}=`;
            const decodedCookie = decodeURIComponent(document.cookie || '');
            const ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        },
        handleBackNavigation() {
            if (this.$route && this.$route.name === 'cart.summary' && this.cart_summary_checkout_step === 2) {
                this.setCartSummaryCheckoutStep(1);
                return;
            }

            if (this.$route && this.$route.name === 'orders.summary') {
                this.$router.push({name: 'home'}).catch(() => {});
                return;
            }
            // Controlla se c'è cronologia disponibile
            if (window.history.length > 1) {
                this.$router.back();
                return;
            }
            this.$router.push({name: 'home'}).catch(() => {});
        },
        isMobile() {
          return !!window.isKuokkoMobileApp;
        },
        applyMaintenanceState(isMaintenance, maintenanceText = null) {
            this.maintenance = isMaintenance;
            this.maintenanceText = maintenanceText;
            this.show_navbar = !this.splashscreen_visible && !this.maintenance && this.$route.meta.showNav;
            this.show_optionbar = !this.splashscreen_visible && !this.maintenance && this.$route.meta.showOptionbar;
        },
        handleMaintenanceUnlocked() {
            this.maintenance_unlocked = true;
            this.applyMaintenanceState(false, null);
        },
        fetchInfo: function () {
            getRestaurantInfo(this.language, {
                id_ristorante: this.id_ristorante
            }).then(response => {
                this.initialize({
                    id: this.idRistorante,
                    targa: this.targaRistorante,
                    servizi_attivi: response.servizi_attivi,
                    locali: response.locali,
                    impostazioni: response.impostazioni,
                    monete: response.monete,
                    punti_di_servizio: response.punti_di_servizio,
                    franchising: response.franchising,
                    f_stripe: response.f_stripe,
                    f_modalita_fiera: response.f_modalita_fiera,
                    f_distretto: response.f_distretto,
                    specific_translations: response.specific_translations,
                    f_deliverect: response.f_deliverect
                });

                if (this.$route.name === "user.password.reset") {
                    if (this.$route.query.idLocale) {
                        this.setLocale(this.restaurant.locali.find((room) => {
                            return room.id == this.$route.query.idLocale;
                        }));
                    }
                }

                this.lingue_attive = response.lingue_attive;

                const newLanguageCode = this.checkLanguage();
                if (newLanguageCode) {
                    this.setLanguage(newLanguageCode);
                } else {
                    this.fetchMoreInfo();
                    setInterval(() => {
                        this.fetchMoreInfo();
                    }, 100000);
                }

                if (response.facebook_pixel_id) {
                    this.$analytics.fbq.init(response.facebook_pixel_id, {
                        router: this.$router
                    });
                    this.$analytics.fbq.event('PageView');
                }
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });
        },
        fetchMoreInfo: function () {

            const promises = [this.retrieveMaintenanceStatus()];

            if (this.locale && this.enableCoupons) {
                promises.push(this.retrieveCouponCounter());
            }

            if (this.userAuthenticated) {
                promises.push(this.retrieveMessages());
            }

            if (this.locale) {
                promises.push(this.retrievePrivacyCheckboxes());
            }

            axios.all(promises).then(() => {
                if (this.splashscreen_visible) {
                    if (!this.locale) {
                        this.goToMain();
                    }

                    this.showSplashscreen(false);

                    // Per l'app mobile
                    if (window.ReactNativeWebView) {
                        this.setupMobileMessages();
                        window.ReactNativeWebView.postMessage(
                            JSON.stringify({
                                type: 'WEBAPP_READY'
                            })
                        );
                    }

                    this.show_navbar = !this.maintenance && this.$route.meta.showNav;
                    this.show_optionbar = !this.maintenance && this.$route.meta.showOptionbar;
                    this.startBlinker();

                    //start timer ordine
                    if (this.order.time_limit) {
                        this.startOrderAlertTime({
                            end_date: this.order.time_limit
                        });
                    }
                }
            }).catch(error => {
                // react on errors.
                console.log('Generic ERROR:', error);
            });
        },
        retrieveMaintenanceStatus: async function () {
            let response = null;

            try {
                response = await getStatus(this.language, {
                    id_ristorante: this.id_ristorante,
                });
            } catch ({messages}) {
                alert(messages.join('\n'));
                throw "maintenance request failed";
            }

            if (response) {
                const nuoviLocali = [];
                let shouldUpdateLocali = false;
                response.infoLicenze.forEach((infoLicenza) => {
                    const vecchioLocale = this.restaurant.locali.find(vecchioLocale => vecchioLocale.id === infoLicenza.id_locale);

                    if (vecchioLocale) {
                        if (infoLicenza.f_locale_morto) {
                            shouldUpdateLocali = true;
                        } else {
                            vecchioLocale.licenza = infoLicenza;
                            nuoviLocali.push(vecchioLocale);
                            shouldUpdateLocali = true;
                        }
                    }
                });

                if (shouldUpdateLocali) {
                    //Qui entra solo se i locali sono diversi dal primo fetch, quindi non trigghera il watch sul locale la prima volta
                    this.setLocali(nuoviLocali);
                    if (this.locale) {
                        const localeAttuale = nuoviLocali.find(nuovoLocale => nuovoLocale.licenza.f_attivo && nuovoLocale.id === this.locale.id);
                        if (localeAttuale) {
                            this.setLocale(localeAttuale);
                        } else {
                            this.goToMain();
                        }
                    }
                }

                let nextMaintenance = false;
                let nextMaintenanceText = null;

                if (response.manutenzione || !nuoviLocali.length) {
                    nextMaintenance = true;
                } else if (!nuoviLocali.find(nuovoLocale => nuovoLocale.licenza.f_attivo)) {
                    nextMaintenance = true;
                    nextMaintenanceText = nuoviLocali[0].licenza.testo;
                }

                if (!nextMaintenance) {
                    this.maintenance_unlocked = false;
                    this.applyMaintenanceState(false, null);
                } else if (this.maintenance_unlocked) {
                    this.applyMaintenanceState(false, null);
                } else {
                    this.applyMaintenanceState(true, nextMaintenanceText);
                }
            }
        },
        retrieveCouponCounter: async function () {
            let response = null;

            try {
                response = await getCoupons(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    api_key: this.user.api_key,
                    f_nascosto: 0,
                    counter_form: true
                });
            } catch ({messages}) {
                alert(messages.join('\n'));
            }

            if (response) {
                this.counter_discount_codes = response.codici_sconto;
            }
        },
        retrieveMessages: async function () {
            let response = null;

            try {
                response = await status(this.language, {
                    id_ristorante: this.id_ristorante,
                    api_key: this.user.api_key,
                    with_chat: !this.can_receive_notifications
                });
            } catch ({messages}) {
                alert(messages.join('\n'));
            }

            if (response) {
                if (!this.can_receive_notifications) {
                    if (('Notification' in window)) {
                        const deliverNotifications = (messages) => {
                            messages.forEach((message) => {
                                const found_message = this.unread_messages.find((current_message) => {
                                    return message.id === current_message.id
                                });

                                if (!found_message) {
                                    const notification = new Notification(
                                        message.chat.chatable_type + ' n.' + message.chat.chatable_id,
                                        {body: message.messaggio}
                                    );
                                }
                            });
                        };

                        if (Notification.permission === 'granted') {
                            deliverNotifications(response.messages_not_read);
                        } else if (Notification.permission !== 'denied') {
                            Notification.requestPermission().then((permission) => {
                                if (permission === 'granted') {
                                    deliverNotifications(response.messages_not_read);
                                }
                            });
                        }
                    }
                }

                this.setUnreadMessages(response.messages_not_read);
                //response.f_notifiche_a ???
            }
        },
        checkLanguage: function () {
            let foundLanguage = null;
            if (!this.initialized) {
                foundLanguage = this.lingue_attive.find(language => language.codice === this.$root.$i18n.fallbackLocale);
            }

            if (!foundLanguage) {
                foundLanguage = this.lingue_attive.find(language => language.codice === this.language);
                if (!foundLanguage) {
                    if (this.lingue_attive.length) {
                        foundLanguage = this.lingue_attive[0];
                    }
                }
            }

            if (!this.initialized || foundLanguage.codice !== this.language) {
                return foundLanguage.codice;
            }

            return false;
        },
        handleLogout: function () {
            this.removeUserData();
            this.$router.replace({name: 'home'}).catch(err => {
                //vuol dire che sono già nella home
            });
        },
        //START Notifications
        setupFirebase: async function () {
            try {
                await firebase.setup(this.targaRistorante);
                const token = await firebase.setupMessaging(
                    this.fwpcRistorante,
                    this.userAuthenticated
                );
                if (token) {
                    firebase.addOnMessageCallback(this.onFirebaseMessage);

                    await sendFirebaseToken(this.language, {
                        id_ristorante: this.id_ristorante,
                        email: this.user.email,
                        api_key: this.user.api_key,
                        token,
                        type: "FCM",
                        unique_id: this.user.iid
                    });

                    this.can_receive_notifications = true;
                }
            } catch (e) {
                this.can_receive_notifications = false;
            }
        },
        retrievePrivacyCheckboxes: async function () {
            if (!this.locale || !this.id_ristorante) return;

            const cacheKey = `${this.language}:${this.locale.id}`;
            if (this.privacy_cache_key === cacheKey && this.privacy_checkboxes.length) return;

            try {
                const response = await getPrivacyCheckboxes(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    for_general: true
                });
                this.privacy_checkboxes = response.checkboxes || [];
                this.privacy_cache_key = cacheKey;
            } catch ({messages}) {
                console.warn('Privacy checkboxes error:', messages);
            }
        },
        openPrivacyModal: async function (payload) {
            if (payload === 'cookie') {
                this.openCookiePolicyModal();
                return;
            }

            let checkbox = null;

            if (typeof payload === 'string') {
                await this.retrievePrivacyCheckboxes();
                checkbox = this.privacy_checkboxes.find((item) => {
                    return item.url && item.url.includes(`/privacy-app/${payload}`);
                });
            } else if (payload && payload.url) {
                checkbox = payload;
            }

            if (!checkbox) return;

            this.current_privacy_checkbox = checkbox;
            this.show_privacy_modal = true;
        },
        setupMobileMessages: function () {
            // Listener globale per messaggi da React Native
            window.addEventListener("message", async (event) => {
                let data = event.data;
                try {
                    data = JSON.parse(data);
                    if (data.type === "FCM_TOKEN") {
                        // Se l'utente è loggato, salva il token FCM
                        if (this.userAuthenticated) {
                            await sendFirebaseToken(this.language, {
                                id_ristorante: this.id_ristorante,
                                email: this.user.email,
                                api_key: this.user.api_key,
                                token: data.payload,
                                type: "FCM",
                                unique_id: this.user.iid
                            });

                            this.can_receive_notifications = true;
                        }
                    } else if (data.type === "FCM_MESSAGE") {
                        if (window.ReactNativeWebView) {
                            this.onFirebaseMessage(data.payload);
                        }
                    } else if (data.type === "FIRST_FCM_MESSAGE") {
                        if (window.ReactNativeWebView) {
                            this.initialMobileNotificationCheck(data.payload);
                        }
                    } else if (data.type === "APP_OPENED_FCM_MESSAGE") {
                        if (window.ReactNativeWebView) {
                            this.initialMobileNotificationCheck(data.payload);
                        }
                    } else if (data.type === "APPSTATE_CHANGE") {
                        //
                    }
                } catch (e) {
                    //
                }
            });
        },
        initialMobileNotificationCheck: function (payload) {
            try {
                const notifData = payload.data;
                if (!notifData) return;

                switch (notifData.type) {
                    case 'CHAT_MESSAGE':
                        this.$router.push({name: 'messaging'});
                        break;
                    case 'CODICE_SCONTO':
                        this.$router.push({name: 'orders.discounts'});
                        break;
                    case 'NEWS':
                        this.$router.push({name: 'news.details', params: {id: notifData.id_news }});
                        break;
                    case 'ORDER':
                        if (notifData.id_ordine || notifData.order_id) {
                            this.$router.push({
                                name: 'orders.details',
                                params: {
                                    id: notifData.id_ordine || notifData.order_id
                                }
                            });
                        } else {
                            this.$router.push({name: 'orders.history'});
                        }
                        break;
                    case 'NOTIFICA_COMMERCIALE':
                        // TODO: quando verranno utilizzate
                        /*if (notifData.f_feedback) {
                            this.$router.push({
                                name: 'orders.details',
                                params: {
                                    id: notifData.id_ordine
                                }
                            });
                        } else {
                            this.$router.push({name: 'notifications'});
                        }*/
                        break;
                }
            } catch (e) {
                console.error('Error handling notification:', e);
            }
        },
        onFirebaseMessage: function (payload) {
            // ...
            switch (payload.data.type) {
                case 'CHAT_MESSAGE':
                    this.addUnreadMessage(JSON.parse(payload.data.raw_db));
                    break;
                case 'MARK_MESSAGES':
                    this.setMessageReadDatetime(JSON.parse(payload.data.messages_ids));
                    break;
                case 'CODICE_SCONTO':
                    const rooms_id = JSON.parse(payload.data.rooms_id);
                    if (rooms_id.includes(this.locale.id.toString())) {
                        this.counter_discount_codes += 1;
                    }
                    break;
                default:
                    console.warn('type not recognized:', payload.data.type);
                    break;
            }

            if (payload.notification) {
                const notificationTitle = payload.notification.title;
                const notificationOptions = {
                    body: payload.notification.body.substr(0, 50),
                    icon: '/img/ico/favicon.ico',
                };
                // If it's okay let's create a notification
                const notification = new Notification(notificationTitle, notificationOptions);
                notification.onclick = function (e) {
                    this.$router.push({name: 'messaging'}).catch(() => {
                        //we are already in messaging section
                    });
                    notification.close();
                };
            }
        },
        goToMain: function () {
            let service = null;
            let point = null;

            if (this.restaurant.f_distretto || (this.restaurant.f_modalita_fiera && this.restaurant.punti_di_servizio && this.restaurant.punti_di_servizio.length)) {
                if (this.restaurantServices().length > 1) {
                    this.$router.replace({name: 'rooms.type'});
                } else if (this.restaurantServices().length) {
                    service = this.restaurantServices()[0];

                    if (service === 'DIL') {
                        if (this.restaurant.punti_di_servizio.length > 1) {
                            this.$router.replace({name: 'rooms.zone', query: {service}});
                        } else if (this.restaurant.punti_di_servizio.length) {
                            point = this.restaurant.punti_di_servizio.punti_di_servizio[0];

                            const roomsIds = point.conf_ordini_prenotazioni_pds.map(
                                (conf) => conf.id_locale,
                            );

                            const rooms = this.restaurant.locali.filter((room) => {
                                return roomsIds.includes(room.id);
                            });

                            if (this.restaurant.franchising && rooms.length > 1) {
                                this.$router.replace({name: 'rooms', query: {service, pointId: point.id}});
                            } else {
                                this.setLocale(locale);
                                this.setDefaultParams({
                                    id_punto_di_servizio_default: point.id,
                                    type_default: service
                                });
                                this.$router.replace({name: 'home'});
                            }
                        }
                    }
                }
            } else if (this.restaurant.franchising && this.restaurant.locali.length > 1) {
                this.$router.replace({name: 'rooms'});
            } else {
                this.setLocale(locale);
                this.$router.replace({name: 'home'});
            }
            //se arrivi qui caro mio...sei nella merda più totale
        },
        //END Notifications
        ...mapActions('global', [
            'showSplashscreen',
            'showModalErrors',
            'setCartSummaryCheckoutStep'
        ]),
        ...mapActions('restaurant', [
            'initialize',
            'setLocale',
            'setLocali'
        ]),
        ...mapActions('localization', [
            'setLanguage'
        ]),
        ...mapActions('auth', [
            'removeUserData'
        ]),
        ...mapActions('chat', [
            'setUnreadMessages',
            'addUnreadMessage',
            'setMessageReadDatetime'
        ]),
        ...mapActions('order', {
            startBlinker: 'startBlinker',
            startOrderAlertTime: 'startAlertTime',
            setDefaultParams: 'setDefaultParams'
        })
    }
}
</script>
